import { render, staticRenderFns } from "./api-source.vue?vue&type=template&id=25388fb4&scoped=true&"
import script from "./api-source.vue?vue&type=script&lang=js&"
export * from "./api-source.vue?vue&type=script&lang=js&"
import style0 from "./api-source.vue?vue&type=style&index=0&id=25388fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25388fb4",
  null
  
)

export default component.exports